import { useEffect, useState } from "react";
import "../Stylesheets/Dashboard/Dashboard.css";
import { People, CarFront, Hammer, Mouse, BoxArrowInRight, PersonLock } from "react-bootstrap-icons";
import api, { isCanceled } from "../lib/api";

const EMPTY_DATA = {
    users: 0, vehicles: 0, bids: 0, history: 0,
    copart_logins: 0, iaai_logins: 0,
    accounts: { copart: 0, iaai: 0 },
};

const Dashboard = () => {
    const [data, setData] = useState(EMPTY_DATA);
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();

        Promise.all([
            api.get("/dashboard", { signal: controller.signal }),
            api.get("/alerts", { signal: controller.signal }),
        ])
            .then(([dashboardRes, alertsRes]) => {
                // Merged into the defaults rather than replacing them wholesale:
                // a response without `accounts` used to make `data.accounts.copart`
                // throw and blank the page.
                const payload = dashboardRes.data.data || {};
                setData({
                    ...EMPTY_DATA,
                    ...payload,
                    accounts: { ...EMPTY_DATA.accounts, ...(payload.accounts || {}) },
                });
                setAlerts(Array.isArray(alertsRes.data.data) ? alertsRes.data.data : []);
            })
            .catch((err) => {
                if (isCanceled(err)) return;
                setData(EMPTY_DATA);
                setAlerts([]);
            })
            .finally(() => setLoading(false));

        return () => controller.abort();
    }, []);

    const cards = [
        { label: "Users", value: data.users, Icon: People },
        { label: "Won Cars", value: data.vehicles, Icon: CarFront },
        { label: "Bids Count", value: data.bids, Icon: Hammer },
        { label: "Actions Count", value: data.history, Icon: Mouse },
        { label: "Copart Login", value: data.copart_logins, Icon: BoxArrowInRight },
        { label: "IAAI Login", value: data.iaai_logins, Icon: BoxArrowInRight },
        { label: "Copart Accounts", value: data.accounts.copart, Icon: PersonLock },
        { label: "IAAI Accounts", value: data.accounts.iaai, Icon: PersonLock },
    ];

    return (
        <div className="page-content-container">
            <h2 className="page-title">Dashboard</h2>
            <div className="dashboard-cards-container">
                {/* Each card used the same generic Person icon; they are now
                    distinguishable at a glance. */}
                {cards.map(({ label, value, Icon }) => (
                    <div className="dashboard-card" key={label}>
                        <div className="dashboard-card-header">
                            <Icon size={22} className="dashboard-card-icon" />
                            <h3 className="dashboard-card-title">{label}</h3>
                        </div>
                        <p className={`dashboard-card-value ${loading ? "is-loading" : ""}`}>
                            {loading ? "—" : Number(value ?? 0).toLocaleString()}
                        </p>
                    </div>
                ))}
            </div>

            <div className="dashboard-alerts-container">
                <h2 className="page-title dashboard-alerts-title">Messages</h2>
                <div className="dashboard-alerts-cards-container">
                    {alerts.map((alert) => (
                        <div
                            key={alert.id}
                            className="dashboard-alert-card"
                            style={{ borderLeftColor: alert.alert_type || "var(--accent)" }}
                        >
                            <h3 className="dashboard-alert-card-title" style={{ color: alert.alert_type }}>{alert.title}</h3>
                            <p className="dashboard-alert-card-message">{alert.html}</p>
                        </div>
                    ))}
                    {!loading && alerts.length === 0 && <p className="dashboard-empty">No messages</p>}
                </div>
            </div>
        </div>
    )
}

export default Dashboard
